import React from 'react';
import {
  Alert,
  Badge
} from 'react-bootstrap';
import PMono from './p/PMono'
//import PText from './p/PText'
import PTextLabel from './p/PTextLabel'
import utils from '../utils'

function get_model_name(code) {
  var items = [
    { name: "LEONARDO",           code: 0,    },
    { name: "ETAGAS",             code: 1,    },
    { name: "EFS500",             code: 2,    },
    { name: "BOOTLOADER",         code: 3,    },
    { name: "INIEZIONE_MULTI",    code: 4,    },
    { name: "PALMARE_OBD",        code: 5,    },
    { name: "NGV_DIESEL",         code: 6,    },
    { name: "KANGOO",             code: 7,    },
    { name: "AEB2001",            code: 10,   },
    { name: "LRE180",             code: 18,   },
    { name: "LRE184",             code: 20,   },
    { name: "LRE188",             code: 23,   },
    { name: "TAR345",             code: 24,   },
    { name: "AEB2001N",           code: 30,   },
    { name: "AEB2568",            code: 31,   },
    { name: "TAR2568",            code: 33,   },
    { name: "AEB2001NE",          code: 37,   },
    { name: "AEB2568T",           code: 38,   }, 
    { name: "TAR2568T",           code: 39,   },
    { name: "AEB2010",            code: 53,   },
    { name: "AEB2564V",           code: 54,   },
    { name: "AEB2001N_C",         code: 55,   },
    { name: "AEB2568D",           code: 56,   },
    { name: "TAR345D",            code: 57,   },
    { name: "TAR2568D",           code: 58,   }, 
    { name: "TAR345D_OE",         code: 77,   }, // tipo Mercedes
    { name: "TAR2568D_OE",        code: 78,   }, 
    { name: "AEB2001N_MONOPLUG",  code: 79,   },
    { name: "AEB2001MPOBD",       code: 88,   }, // !!! EX AEB2001MP
    { name: "MP32",               code: 93,   },
    { name: "MP6C",               code: 94,   },
    { name: "NON_IN_PRODUZIONE",  code: 255,  },
  ]
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.code === code) {
      return item.name
    }
  }
  return undefined
}

function get_customer_name(code) {
  var items = [
    { name: "AEB",              code: 0x00, },
    { name: "LANDI_RENZO",      code: 0x01, },
    { name: "LANDI_SRL",        code: 0x02, },
    { name: "BOEMO",            code: 0x03, },
    { name: "TECHNOCARB",       code: 0x04, },
    { name: "LOVATO",           code: 0x05, },
    { name: "ICOM",             code: 0x06, },
    { name: "ZAVOLI",           code: 0x07, },
    { name: "TARTARINI",        code: 0x08, },
    { name: "ELPIGAZ",          code: 0x09, },
    { name: "OMVL",             code: 0x0a, },
    { name: "ELPIGAZNEW",       code: 0x0b, },
    { name: "NGV",              code: 0x0c, },
    { name: "RODAGAS",          code: 0x0d, },
    { name: "ROMANO",           code: 0x0e, },
    { name: "GASMOBIL",         code: 0x0f, },
    { name: "MOTORGLP",         code: 0x10, },
    { name: "BRC",              code: 0x11, },
    { name: "BIGAS",            code: 0x12, },
    { name: "FASANOALF",        code: 0x13, },
    { name: "MARINI",           code: 0x14, },
    { name: "LOVTEC",           code: 0x15, },
    { name: "EMMEGAS",          code: 0x16, },
    { name: "EUROGAS",          code: 0x17, },

    { name: "DAEWOO",           code: 0x1A, },
    { name: "RENAULT",          code: 0x1B, },
    { name: "AUTOGERMA",        code: 0x1C, },
    { name: "SUZUKI",           code: 0x1D, },
    { name: "TOMMASETTO",       code: 0x1E, },
    { name: "EMER",             code: 0x1F, },
    { name: "OPEL",             code: 0x20, },
    { name: "DAIHATSU",         code: 0x21, },
    { name: "EUROGAS_OLANDA",   code: 0x22, },
    { name: "EUROGAS_EXPORT",   code: 0x23, },
    { name: "KIA",              code: 0x24, },
    { name: "LOVATO_CITROEN",   code: 0x25, },
    { name: "NGV_CINA",         code: 0x26, },
    { name: "KING",             code: 0x27, },
    { name: "ENERGY",           code: 0x28, },
    { name: "TAINING",          code: 0x29, },
    { name: "VOGELS",           code: 0x2A, },
    { name: "BUGATTI",          code: 0x2B, },
    { name: "CGS",              code: 0x2C, },
    { name: "ATIKER",           code: 0x2D, },
    { name: "EUROGAS_LANDI",    code: 0x2E, },
    { name: "OYRSA",            code: 0x2F, },
   
    { name: "SUBCLIENT_GROUP_TAR_AEB",  code: 252, }, // sottoclienti al comando 51 (subClient)
    { name: "GRUPPO_AEB",               code: 253, },
    { name: "GRUPPO_LANDI",             code: 254, },
    { name: "CLIENTE_GENERICO",         code: 255, },
  ]
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.code === code) {
      return item.name
    }
  }
  return undefined
}

export default class EcuMessageId extends React.Component {
  //constructor(props) {    
  //  super(props)    
  //}
  render() {    
    if (this.props.data === undefined) 
      return ""

    // console.log(this.props.data)

    var t_customer = this.props.data.customer
    var c_name = get_customer_name(this.props.data.customer)
    if (c_name !== undefined) {
      //t_customer += " (" + c_name + ")"
    }
    var t_model = this.props.data.model
    var m_name = get_model_name(this.props.data.model)
    if (m_name !== undefined) {
      //t_model += " (" + m_name + ")"
    }

    var t_fwVersion     = this.props.data.fwVersion
    var t_is_boot_str   = this.props.data.isBootStr

    var hex_bytes = utils.byteArrayToHex(this.props.data._b)
    var ko_visible = (!this.props.data.res) ? "visually-hidden" : ""

    if (this.props.data.isBoot)
    {
      return (
        <>           
          <Alert variant="warning">
          <Alert.Heading>{this.props.title} <Badge bg="danger" className={ko_visible}>KO</Badge></Alert.Heading>
            <PMono value={hex_bytes} />
            <hr />
            <PTextLabel label="Is Boot" value={t_is_boot_str} />          
          </Alert>
        </>
      )  
    }
    return (
      <>           
        <Alert variant="info">
        <Alert.Heading>{this.props.title} <Badge bg="danger" className={ko_visible}>KO</Badge></Alert.Heading>
          <PMono value={hex_bytes} />
          <hr />
          <PTextLabel label="Customer"      value={t_customer}    description={c_name} />
          <PTextLabel label="Model"         value={t_model}       description={m_name} />          
          <PTextLabel label="Fw Version"    value={t_fwVersion}   />          
          <PTextLabel label="Is Boot"       value={t_is_boot_str} />          
        </Alert>
      </>
    )
  }
}
